// src/pages/ambulances/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import LayoutShell from "@/components/ui/LayoutShell.jsx";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";
import AmbulanceResultCard from "@/components/ambulance/AmbulanceResultCard.jsx";
import AmbulancesFilterSheet from "@/pages/ambulances/AmbulancesFilterSheet.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

const AMBULANCES = [
  {
    id: "kalafhi-ambulance",
    name: "Kalafhi Medical Center",
    address: "8WJJ+2MR, Kgaladua, Gaborone, Botswana",
    image: "/assets/images/ambulances/ambulance.634.jpg",
    time: "6 min",
    rating: null,
    isFavorite: true,
  },
  {
    id: "sidilega-ambulance",
    name: "Sidilega Private Hospital",
    address: "59932 Basotho Dr, Gaborone, Botswana",
    image: "/assets/images/ambulances/ambulance.111.jpg",
    time: "7 min",
    rating: null,
    isFavorite: false,
  },
  {
    id: "riverside-ambulance",
    name: "Riverside Hospital",
    address: "424 Baines Ave, Francistown, Botswana",
    image: "/assets/images/ambulances/ambulance.117.jpg",
    time: "7 min",
    rating: null,
    isFavorite: true,
  },
  {
    id: "lenmed-ambulance",
    name: "Lenmed Bokamoso Private Hospital",
    address: "Plot 2435, Block 1 Mmopane, Gaborone",
    image: "/assets/images/ambulances/ambulance.128.jpg",
    time: "7 min",
    rating: null,
    isFavorite: false,
  },
  {
    id: "multicare-ambulance",
    name: "MultiCare Medical Center",
    address: "Gaborone, Botswana",
    image: "/assets/images/ambulances/ambulance.177.jpg",
    time: "7 min",
    rating: null,
    isFavorite: false,
  },
  {
    id: "ambulance-120",
    name: "Ambulance # 120",
    address: "1 Paramedic, 1 Driver",
    image: "/assets/images/ambulances/ambulance.634.jpg",
    time: "7 min",
    rating: null,
    isFavorite: true,
  },
];

export default function AmbulancesPage() {
  const nav = useNavigate();
  const { t } = useLanguage();

  // Same filter shape as the other facilities
  const [filters, setFilters] = React.useState({
    data: ["near-you"],
    payment: [],
  });

  const [isFilterOpen, setIsFilterOpen] = React.useState(false);

  const activeFilterCount = React.useMemo(() => {
    const d = filters.data?.length || 0;
    const p = filters.payment?.length || 0;
    return d + p;
  }, [filters]);

  return (
    <>
      <LayoutShell>
        <div className="afrimed-rail afrimed-rail--comfortable px-4 pt-4 pb-24">
          {/* Top bar – Ambulance */}
          <header className="mb-4">
            <TopBarCenter
              title={t("appointments.directory.ambulances.title", "Ambulance")}
              close
              onBack={() => nav(-1)}
            />

            {/* Subtitle row – text left, Filter right */}
            <div className="mt-3 flex items-center justify-between px-1">
              <h2 className="text-title-medium text-on-surface-var">
                {t("appointments.directory.ambulances.subtitle", "Ambulances near you")}
              </h2>

              <button
                type="button"
                onClick={() => setIsFilterOpen(true)}
                className="inline-flex items-center gap-1 text-body-medium text-primary"
              >
                <img
                  src="/icons/patient/filter.svg"
                  alt=""
                  className="h-[18px] w-[18px]"
                  draggable="false"
                />
                <span>
                  {t("appointments.directory.common.filter", "Filter")}
                  {activeFilterCount > 0 ? ` · ${activeFilterCount}` : ""}
                </span>
              </button>
            </div>
          </header>

          {/* Results list */}
          <section className="space-y-3">
            {AMBULANCES.map((ambulance) => (
              <AmbulanceResultCard key={ambulance.id} ambulance={ambulance} />
            ))}
          </section>
        </div>
      </LayoutShell>

      {/* Filter sheet */}
      <AmbulancesFilterSheet
        open={isFilterOpen}
        value={filters}
        onChange={setFilters}
        onClose={() => setIsFilterOpen(false)}
      />
    </>
  );
}
